/* @flow */

export default {
  root: {
    display: 'inline-block',

    width: 10,
    height: 10,

    backgroundColor: ({ accentColor }: Object) => accentColor,
    borderRadius: '50%',
  },
  'root-small': {
    width: 6,
    height: 6,
  },
};
